export interface CreditVoucherParams {
  ticketId: string | null;
  membershipType: number;
  membershipIds: string[];
  membershipId: string;
  quantity: number | null;
  deductPoints: number;
  pushNotification: number;
  pushNotificationTitle?: string;
  pushNotificationText?: string;
  pushNotificationUrl?: string;
  addToPocket: number;
  showExclusiveB2CBanner?: number;
  showExclusiveB2CBannerText?: string;
  showExclusiveB2CBannerCta?: string;
  showExclusiveB2CBannerUrl?: string;
  uploadFile: any;
  isValidForm: boolean;
}

export type CreditVoucherValidationTypes = {
  membershipIds?: string;
  quantity?: string;
  pushNotificationTitle?: string;
  pushNotificationText?: string;
  showExclusiveB2CBannerText?: string;
  showExclusiveB2CBannerCta?: string;
  uploadFile?: string;
};

export type MembershipType = {
  type: number;
  membershipIds: string[];
};

export type CsvFileInfosType = {
  nameFile: string;
  size: number;
  totalNumberOfMembers: number;
  membershipIDs: string[];
  isMissingMembershipIDCol: boolean;
};

export function typeRoutes(
  name: string,
  path?: string,
  isCurrentPage?: boolean
) {
  return {name, path, isCurrentPage};
}

export type SelectOptionsProps = {
  label: string;
  value: string;
};
